import { createSlice } from '@reduxjs/toolkit';
import {
  getFieldsByFormId,
  getFormDataById,
  patchFormDataById,

} from "./actionCreator";
import initialState from "./state";

const isJsonParse = (json: string) => {
  try {
    return JSON.parse(json);
  } catch (error) {
    return false;
  }
};

export const formBuilderListSlice = createSlice({
  name: "formBuilder/getAllFormData",
  initialState,
  reducers: {
    setFormData: (state, action) => {
      state.formData = action.payload
    },
    setPaginationModel(state, action) {
      state.paginationModel = { ...state.paginationModel, ...action.payload };
    },

    resetState: () => initialState
  },
  extraReducers: (builder) => {
    /*--------------------------------GET Handle Pending State ---------------------------------*/



    /*--------------------------------GET BY ID Handle Pending State ---------------------------------*/

    builder.addCase(getFormDataById.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = '';
      state.formData = [];
    });

    /*--------------------------------GET BY ID Handle fullfiled State ---------------------------------*/
    builder.addCase(getFormDataById.fulfilled, (state, action: any) => {
      state.isLoading = false;
      state.isError = false;
      state.formData = action?.payload?.data?.form?.fields;
      state.error = "";
    });

    /*--------------------------------GET BY ID Handle Rejected State ---------------------------------*/
    builder.addCase(getFormDataById.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.error.message || "";
    });
    /*--------------------------------Patch Handle Pending State ---------------------------------*/

    builder.addCase(patchFormDataById.pending, (state) => {
      // state.isLoading = true;
      // state.isError = false;
      // state.isSuccess = false;
      // state.error = "";
    });

    /*--------------------------------Patch Handle fullfiled State ---------------------------------*/
    builder.addCase(patchFormDataById.fulfilled, (state) => {
      state.isLoading = false;
      state.isError = false;
      // state.formData = [];
      state.error = "";
      state.isSuccess = true;
    });

    /*--------------------------------Patch Handle Rejected State ---------------------------------*/
    builder.addCase(patchFormDataById.rejected, (state, action) => {
      const error: string = isJsonParse(action.error?.message)?.message || action.error.message || "Something went wrong";
      state.isLoading = false;
      state.isError = true;
      state.error = error;
      state.isSuccess = false;
    });




    /*--------------------------------Get Fields By Form ID handle pending state ---------------------------------*/
    builder.addCase(getFieldsByFormId.pending, (state) => {
      state.isLoading = true;
    });
    /*--------------------------------Get Fields By Form ID handle fullfilled state ---------------------------------*/
    builder.addCase(getFieldsByFormId.fulfilled, (state, action) => {
      const incomingFields = action.payload;
      if (incomingFields.length) {
        let fields = {};
        incomingFields.forEach((field: any) => {
          for (const key in field) {
            fields = {
              ...fields,
              [key]: field[key],
            };
          }
        });
        state.fields = fields;
        state.isLoading = false;
      }
    });
    /*--------------------------------Get Fields By Form ID handle rejected state ---------------------------------*/
    builder.addCase(getFieldsByFormId.rejected, (state, action) => {
      const message = `Fields API: ${isJsonParse(action.error.message as string)?.message ||
        action.error.message
        }`;
      state.isLoading = false;
      state.isError = true;
      state.error = message;
    });
    /*--------------------------------Patch Handle Pending State ---------------------------------*/
  },
});

export const { setFormData, setPaginationModel, resetState } = formBuilderListSlice.actions;

export default formBuilderListSlice.reducer;
